export const creacionDivTitulo = (contenedorCapa, layerName) => {
  //titulo
  const titulo = document.createElement("div");
  titulo.className = "capas-activas-panel-titulo";

  //contenido del titulo
  titulo.alt = "titulo de " + layerName;
  titulo.textContent = layerName;
  contenedorCapa.appendChild(titulo);
};
